export default "dist/images/cb88977ea837bccb9cceb727adc78302.png";